import "../../../../src/pages/posts/2020-05-01_Background_Image_with_Gradient_Overlay/styles.css";
import * as React from 'react';
export default {
  React
};